export default {
    First_Name: {
        id: 12000,
        sysname: 'DEFFIELDS_FIRSTNAME',
        required: true,
        accessor: 'firstName',
        span: false,
        ordinal: 1,
        secondColumnPreference: false,
        cardData: true
    },
    Last_Name: {
        id: 12001,
        sysname: 'DEFFIELDS_LASTNAME',
        required: true,
        accessor: 'lastName',
        span: false,
        ordinal: 2,
        secondColumnPreference: false,
        cardData: true
    },
    Unique_Identifier: {
        id: 12002,
        sysname: 'DEFFIELDS_ID',
        required: true,
        accessor: 'uid',
        span: false,
        ordinal: 4,
        secondColumnPreference: false,
        cardData: true
    },
    Display_Name: {
        id: 12003,
        sysname: 'DEFFIELDS_DISPLAYNAME',
        required: true,
        accessor: 'name',
        span: false,
        ordinal: 3,
        secondColumnPreference: false,
        cardData: true
    },
    Department: {
        id: 12004,
        sysname: 'DEFFIELDS_DEPT',
        accessor: 'department',
        span: false,
        ordinal: 7,
        cardData: false
    },
    Company: {
        id: 12005,
        sysname: 'DEFFIELDS_COMP',
        accessor: 'company',
        span: false,
        ordinal: 6,
        cardData: false
    },
         Title: {
        id: 12006,
        sysname: 'DEFFIELDS_TITLE',
        required: false,
        accessor: 'title',
        span: true,
        ordinal: 1,
        secondColumnPreference: false,
        cardData: false
    },
    Suffix: {
        id: 12007,
        sysname: 'DEFFIELDS_SUFFIX',
        required: false,
        accessor: 'suffix',
        span: false,
        ordinal: 3,
        cardData: false
    },
    Second_Name: {
        id: 12008,
        sysname: 'DEFFIELDS_SECONDNAME',
        required: false,
        accessor: 'middleName',
        span: false,
        ordinal: 2,
        cardData: false
    },
    Gender: {
        id: 12009,
        sysname: 'DEFFIELDS_GENDER',
        required: false,
        accessor: 'gender',
        span: false,
        ordinal: 4,
        cardData: false
    },
    Status: {
        id: 12010,
        sysname: 'DEFFIELDS_STATUS'
    },
    Advanced: {
        id: 12011,
        sysname: 'DEFFIELDS_ADVANCED',
        ordinal: 5
    },
    Quick_Update_Tags: {
        id: 12012,
        sysname: 'DEFFIELDS_QUICKUPDATE'
    },
    Access_Groups: {
        id: 12013,
        sysname: 'DEFFIELDS_ACCESSGROUPS'
    },
    Tags: {
        id: 12014,
        sysname: 'DEFFIELDS_TAGS'
    },
    Notifications: {
        id: 120151,
        sysname: 'DEFFIELDS_NOTIFICATIONS'
    },
    Mobile_Number: {
        id: 12016,
        sysname: 'DEFFIELDS_MOBILE_NUMBER',
        accessor: 'mobileNumber',
        span: false,
        ordinal: 9,
        secondColumnPreference: false,
        cardData: false
    },
    Email_Address: {
        id: 12017,
        sysname: 'DEFFIELDS_EMAIL_ADDR',
        accessor: 'email',
        span: false,
        ordinal: 10,
        secondColumnPreference: false,
        cardData: false
    },
    Pin: {
        id: 12059,
        sysname: 'DEFFIELDS_PIN',
        accessor: 'pin',
        span: false,
        ordinal: 11,
        secondColumnPreference: false,
        cardData: false,
        required: false
    },
    Image: {
        id: 12018,
        sysname: 'DEFFIELDS_IMAGE',
        cardData: true
    },
    Visitor_Vehicle: {
        id: 12019,
        sysname: 'DEFFIELDS_VISITOR_VEHICLE'
    },
    Vehicle_Image: {
        id: 12020,
        sysname: 'DEFFIELDS_VEHICLE_IMAGE',
        cardData: true
    },
    Visitor_Destination: {
        id: 12021,
        sysname: 'DEFFIELDS_VISITOR_DESTINATION'
    },
    Visiting_Period: {
        id: 12022,
        sysname: 'DEFFIELDS_VISITING_PERIOD'
    },
    Master_Type: {
        id: 12032,
        sysname: 'DEFFIELDS_MASTER_TYPE',
        accessor: 'timeAndAttendance',
        secondColumnPreference: true,
        span: false,
        ordinal: 12,
        cardData: false
    },
    Print_Template: {
        id: 12033,
        sysname: 'DEFFIELDS_DEFAULT_CARD',
        required: false,
        accessor: 'printTemplate',
        span: false,
        ordinal: 5,
        cardData: false
    },
    Links: {
        id: 12036,
        sysname: 'DEFFIELDS_PERSONASSET_LINKS'
    },
    Image_Browse_For: {
        id: 12037,
        sysname: 'DEFFIELDS_IMAGE_BROWSE'
    },
    Image_Capture_New: {
        id: 12038,
        sysname: 'DEFFIELDS_IMAGE_CAPTURE'
    },
    Image_Crop: {
        id: 12039,
        sysname: 'DEFFIELDS_IMAGE_CROP'
    },
    Floors: {
        id: 12040,
        sysname: 'DEFFIELDS_FLOORS'
    },
    Current: {
        id: 12057,
        sysname: 'DEFFIELDS_CURRENT',
        accessor: 'enableCredentials',
        span: false,
        ordinal: 5,
        secondColumnPreference: false,
        cardData: true
    },
    APB_Override: {
        id: 12060, // not right id, may be mandatory field
        sysname: 'DEFFIELDS_CURRENT',
        accessor: 'apbOverride',
        span: false,
        ordinal: 6,
        secondColumnPreference: false,
        cardData: true
    },
    Expiry_Reasons: {
        id: 12058,
        sysname: 'DEFFIELDS_EXPIRY_REASONS'
    },
    Status_LED: {
        id: 1005,
        sysname: 'ACT_STATUS_LED'
    },
    LCD: {
        id: 1002,
        sysname: 'ACT_LCD'
    }
}
